module.exports = __webpack_public_path__ + "static/media/stats.bc393049.svg";